import { t, Base, LangSwitch } from 'zf-web-components';
import { useCallback, useContext } from 'react';
import { CONFIG } from 'config';
import { useApp } from '@components';
import { RootContext } from '@stores';
import styles from './style.module.less';
import type { AvailableLanguage, LanguageProps } from 'zf-web-components';
import type { ReactElement } from 'react';

export function Header(): ReactElement {
  const { app } = useApp();
  const root = useContext(RootContext);
  const onLangChange = useCallback((key: string): void => {
    root.local.lang = key as AvailableLanguage;
  }, [root]);

  return (
    <Base.Row className={styles.container} align='middle' justify='space-between'>
      <Base.Col className={styles.logoWrap}>
        <img className={styles.logo} src={`${CONFIG.IMAGE_STATIC}/${app}_logo@2x.png`} />
        <span className={styles.name} >{t(app)}</span>
      </Base.Col>
      <Base.Col className={styles.language}>
        <LangSwitch
          color='black'
          onChange={onLangChange}
          lang={root.local.lang as LanguageProps['lang']}
        />
      </Base.Col>
    </Base.Row>
  );
}
